import axios from 'axios'
import router from '../../router'
const state = {
  mDocItemList: [],
  docItemRtn: ''
}

const getters = {
  getDocItemList (state) {
    return state.mDocItemList
  },
  getTranDocItem (state) {
    return state.docItemRtn
  }
}

const mutations = {
  setDocItemList (state, payload) {
    state.mDocItemList = payload
  },
  setTranDocItem (state, payload) {
    state.docItemRtn = payload
  }
}

const actions = {
  apiDocItemList (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/admin/getDocItem', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setDocItemList', response.data)
          if (response.data.length > 0) {
            // context.commit('setRecommandItem', response.data)
          } else {
            alert('검색 값이 존재하지 않습니다.')
          }
        })
        .catch((error) => {
          alert(error.response.data.message)
          if (error.response.status === 403) {
            sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.replace('/AdminLogin')
          }
        })
    }
  },
  apiTranDocItem (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/admin/tranDocItemList', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setTranDocItem', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/AdminLogin')
            } else {
              alert('status : ' + error.response.status + '\nerror : ' + error.response.error + '\nmassege : ' + error.response.message + '\n담당자에게 문의하세요.')
            }
          })
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/itemmanagement.js